import * as yup from 'yup';

// This list must match configuration in wolt-authentication
const EMPLOYEE_EMAIL_DOMAINS = ['wolt.com', 'external.wolt.com', 'doordash.com', 'dd.wolt.com', 'ext.doordash.com'];

export const isEmployeeEmail = (email: string) =>
  yup.string().email().isValidSync(email) && EMPLOYEE_EMAIL_DOMAINS.some(domain => email.endsWith(`@${domain}`));
